import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { FlatpickrOptions } from "ng2-flatpickr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import Italian from "flatpickr/dist/l10n/it";
import { TutorialService } from "app/auth/service/tutorial.service";
import { IAbsence, IAbsenceForm, IAbsenceType } from "app/auth/models/absences";

@Component({
  selector: "app-popup-sickness",
  templateUrl: "./popup-sickness.component.html",
  styleUrls: ["./popup-sickness.component.scss"],
})
export class PopupSicknessComponent implements OnInit {
  @ViewChild("sickness") sickness;
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public formGroup: FormGroup;
  public basicDateOptions: FlatpickrOptions;
  public absenceTypesList: IAbsenceType[] = [];
  public requireFile: boolean = false;
  public requireNote: boolean = false;
  private attachmentFile: string;
  public notAvailableDate: string[] = [];
  public myAbsences: IAbsence[] = [];
  public fileName: string = null;
  public showErrors: boolean = false;

  constructor(
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public _absencesService: AbsencesService,
    public _utilService: UtilsService,
    public _tutorialService: TutorialService,
  ) {}

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      type: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      note: new FormControl(""),
      from: new FormControl("", [Validators.required]),
      to: new FormControl("", [Validators.required]),
      file: new FormControl(null),
    });

    await this.loadHolidaysTypes();
    await this.notAvailablesDate();
    this.basicDateOptions = {
      altFormat: "d/m/Y",
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
      disable: this.notAvailableDate,
      disableMobile: true,
    };
    this.openModal();
  }

  openModal() {
    this._modalService.open(this.sickness, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
  }

  async loadHolidaysTypes() {
    this.absenceTypesList = await this._absencesService.getTypeList();
    this.absenceTypesList = this.absenceTypesList.filter((item) => item.type === "malattia" || item.type === "infortunio" || item.type === "maternità");
  }

  async notAvailablesDate() {
    await this._absencesService.getMineAbsences();
    this.myAbsences = this._absencesService.myAbsences;
    this.myAbsences = this.myAbsences.filter((item) => item.status == 1);
    this.myAbsences.map((item: IAbsence) => {
      const absenceDate: moment.Moment = moment(item.from.split("T")[0]).utc();
      if (!absenceDate || !absenceDate.isValid) return;

      const from: moment.Moment = moment(item.from).utc();
      const to: moment.Moment = moment(item.to).utc();

      if (item.type.category !== "permesso") {
        // Se è un permesso quindi singolo giorno non facciamo nulla
        const difference: number = to.diff(from, "days");

        for (let i = 0; i <= difference; i++) {
          absenceDate.add(1, "days");
          this.notAvailableDate.push(absenceDate.format("YYYY-MM-DD"));
        }
      }
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this._utilService.toggleAbsencePopup("sickness");
  }

  checkAdditionalInput() {
    let selectedAbsence: IAbsenceType[] = null;
    if (this.formGroup.value.type) {
      let selectedTypeAbsences: number = this.formGroup.value.type;
      selectedAbsence = this.absenceTypesList.filter((item) => item.id === selectedTypeAbsences && (item.require_file === 1 || item.require_note === 1));
      if (selectedAbsence.length > 0) {
        this.requireFile = selectedAbsence[0].require_file === 1;
        this.requireNote = selectedAbsence[0].require_note === 1;
      } else {
        this.requireFile = false;
        this.requireNote = false;
      }
    }

    const selectedTypeName: string = this.absenceTypesList.find((item) => item.id === this.formGroup.value.type).name;
    const namesToCheck = ["Infortunio", "Malattia", "Ricovero", "Ricaduta malattia", "Maternità obbligatoria"];

    if (namesToCheck.includes(selectedTypeName) && this.requireFile) {
      this.formGroup.controls.file.setValidators([Validators.required]);
      this.formGroup.controls.note.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(255)]);
    } else {
      this.formGroup.controls.file.clearValidators();
      this.formGroup.controls.note.clearValidators();
    }

    this.formGroup.controls.file.updateValueAndValidity();
    this.formGroup.controls.note.updateValueAndValidity();
  }

  async handlerChangeFileInput(event: { target: { files: { name: string }[] } }) {
    this.fileName = event.target.files[0].name;
    await this._utilService.convertFileToBase64(event, async (e: { target: { result: string } }) => {
      this.attachmentFile = e.target.result;
    });
  }

  async sendAbsenceRequest() {
    this.showErrors = true;

    // controllo valori

    const from: moment.Moment = moment(this.formGroup.value.from[0]);
    const to: moment.Moment = moment(this.formGroup.value.to[0]);

    if (to < from) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }

    if (this.formGroup.value.from == "" || this.formGroup.value.to == "") {
      await this._utilService.showSWALError({ text: "INSERT_START_DATE" });
      return false;
    }

    if (!this.formGroup.valid) {
      console.error(this.formGroup.errors);
      return false;
    }

    const data: IAbsenceForm = {
      type: this.formGroup.value.type,
      from: from.format("YYYY-MM-DD [00:00:00]"),
      to: to.format("YYYY-MM-DD [00:00:00]"),
      note: this.formGroup.value.note,
    };
    this._utilService.showLoading();
    await this._absencesService
      .sendAbsence(data)
      .then(async (response: { file_name: string; id: number }) => {
        if (this.requireFile) {
          this._utilService.hideLoading();
          const uploadFile = await this._utilService.upload_media("documents", response.file_name, this.attachmentFile);
          if (uploadFile) {
            await this._absencesService.updateAbsence(response.id, { has_file: 1 });
          }
        }
        this._utilService.hideLoading();
        this.callbackFn.emit();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_SICKNESS" });
        this.modalClose();
      })
      .catch(async (response) => {
        if (response === "absence already exist") {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_ABSCENCE_ALREADY_REQUESTED" });
        } else {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_SEND_SICKNESS" });
        }
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Richiesta Malattia";
    this._tutorialService.force_open_modal = true;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup?.controls[field_name]?.status === "INVALID";
    } else {
      return this.formGroup?.controls[field_name]?.status === "INVALID" && this.formGroup?.controls[field_name]?.touched;
    }
  }
}

// [disabled]="!formGroup.value.type && !formGroup.value.from && !formGroup.value.to"
